module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/left-img-e8a913d59f24d0cc60b43767fcfa9be5.png";